var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('bread-crumb'),_c('progress-bar',{attrs:{"order_status":_vm.order_status}}),_c('div',{staticClass:"wrap"},[_c('follow',{ref:"follow",staticClass:"follow"}),_c('add-follow-cost',{staticClass:"add-follow-cost",on:{"addFollow":_vm.addFollow}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }